import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../services/auth.service";
import { setUser } from "../../stores/user";

const required = (value) => {
  if (!value) {
    return (
      <div
        className="alert alert-danger"
        role="alert"
      >
        This field is required!
      </div>
    );
  }
};
function Register() {
  const user = useSelector((store) => store.user);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password_confirmation, setPassword_confirmation] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("");
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleLogin = (e) => {
    e.preventDefault();
    AuthService.register(name, email, password, password_confirmation).then(
      (response) => {
        if (response.data.token) {
          dispatch(setUser(response.data));
          navigate(location.pathname);
          setSuccess(true);
        } else {
          // console.log(response.data.error)
          setServermessage(response.data.error || response.data.data);
        }
      }
    );
  };

  useEffect(() => {}, [success]);

  return (
    //  New Tailwind login form
    <div className="flex justify-center items-center min-h-screen">
      <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-full max-w-md">
        <span className="text-red-600">{servermessage}</span>
        <h2 className="text-3xl font-bold mb-6 text-center text-white">
          <span className="bg-gradient-to-r text-transparent from-blue-500 to-purple-500 bg-clip-text">
            Register
          </span>
        </h2>
        <form onSubmit={handleLogin}>
          <div className="mb-6">
            <label
              id="name"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-envelope mr-2"></i>Name
            </label>
            <div>
              <input
                id="name"
                type="name"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your name"
                name="username"
                value={name}
                onChange={(e) => setName(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="mb-6">
            <label
              id="email"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-envelope mr-2"></i>Email
            </label>
            <div>
              <input
                id="email"
                type="email"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your email"
                name="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="mb-6">
            <label
              id="password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-lock mr-2"></i>Password
            </label>
            <div>
              <input
                id="password"
                type="password"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="mb-6">
            <label
              id="corfirm-password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-lock mr-2"></i>Confirm Password
            </label>
            <div>
              <input
                id="password_confirmation"
                type="password"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Confirm password"
                name="password_confirmation"
                value={password_confirmation}
                onChange={(e) => setPassword_confirmation(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline w-full"
            >
              Register
            </button>
          </div>
          <div className="flex row gap-36 text-center mt-4">
            <Link
              to="/forgotpassword"
              className="text-gray-600 hover:underline "
            >
              Forgot password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;

// function Register() {
//   const initialstate = {
//     username: "",
//     email: "",
//     password: "",
//     successful: false,
//     message: "",
//   };
//   const [user, setUser] = useState(initialstate);
//   const handleInput = () => {
//     console.log("hhe");
//   };
//   return (
//     <div className="col-md-12">
//       <div className="card card-container">
//         <img
//           src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
//           alt="profile-img"
//           className="profile-img-card"
//         />

//         <Form>
//           {!user.successful && (
//             <div>
//               <div className="form-group">
//                 <label htmlFor="username">Username</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="username"
//                   value={user.username}
//                   onChange={handleInput}
//                   // validations={[required, vusername]}
//                 />
//               </div>

//               <div className="form-group">
//                 <label htmlFor="email">Email</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="email"
//                   value={user.email}
//                   onChange={handleInput}
//                   // validations={[required, email]}
//                 />
//               </div>

//               <div className="form-group">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   name="password"
//                   value={user.password}
//                   onChange={handleInput}
//                   // validations={[required, vpassword]}
//                 />
//               </div>

//               <div className="form-group">
//                 <button
//                   onClick={() => {
//                     console.log("submit");
//                   }}
//                   className="btn btn-primary btn-block"
//                 >
//                   Sign Up
//                 </button>
//               </div>
//             </div>
//           )}

//           {user.message && (
//             <div className="form-group">
//               <div
//                 className={
//                   user.successful ? "alert alert-success" : "alert alert-danger"
//                 }
//                 role="alert"
//               >
//                 {user.message}
//               </div>
//             </div>
//           )}
//         </Form>
//       </div>
//     </div>
//   );
// }

// export default Register;
